 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLEPAGE from '@/components/titlepage'
 import OEBPSTEXTTITLEPAGE from '@/components/OEBPS/Text/titlepage'
 import OEBPSTEXTCOPYRIGHTPAGE from '@/components/OEBPS/Text/copyrightpage'
 import OEBPSTEXTDEDICATION from '@/components/OEBPS/Text/dedication'
 import OEBPSTEXTTOC from '@/components/OEBPS/Text/toc'
 import OEBPSTEXTPREFACE from '@/components/OEBPS/Text/preface'
 import OEBPSTEXTACKNOWLEDGMENT from '@/components/OEBPS/Text/acknowledgment'
 import OEBPSTEXTPART01 from '@/components/OEBPS/Text/part01'
 import OEBPSTEXTCH01 from '@/components/OEBPS/Text/ch01'
 import OEBPSTEXTPART02 from '@/components/OEBPS/Text/part02'
 import OEBPSTEXTCH02 from '@/components/OEBPS/Text/ch02'
 import OEBPSTEXTCH03 from '@/components/OEBPS/Text/ch03'
 import OEBPSTEXTCH04 from '@/components/OEBPS/Text/ch04'
 import OEBPSTEXTPART03 from '@/components/OEBPS/Text/part03'
 import OEBPSTEXTPROLOGUE from '@/components/OEBPS/Text/prologue'
 import OEBPSTEXTCH05 from '@/components/OEBPS/Text/ch05'
 import OEBPSTEXTCH06 from '@/components/OEBPS/Text/ch06'
 import OEBPSTEXTPART04 from '@/components/OEBPS/Text/part04'
 import OEBPSTEXTCH07 from '@/components/OEBPS/Text/ch07'
 import OEBPSTEXTCODA from '@/components/OEBPS/Text/coda'
 import OEBPSTEXTNOTES_SPLIT_000 from '@/components/OEBPS/Text/notes_split_000'
 import OEBPSTEXTNOTES_SPLIT_001 from '@/components/OEBPS/Text/notes_split_001'
 import OEBPSTEXTNOTES_SPLIT_002 from '@/components/OEBPS/Text/notes_split_002'
 import OEBPSTEXTNOTES_SPLIT_003 from '@/components/OEBPS/Text/notes_split_003'
 import OEBPSTEXTNOTES_SPLIT_004 from '@/components/OEBPS/Text/notes_split_004'
 import OEBPSTEXTNOTES_SPLIT_005 from '@/components/OEBPS/Text/notes_split_005'
 import OEBPSTEXTNOTES_SPLIT_006 from '@/components/OEBPS/Text/notes_split_006'
 import OEBPSTEXTNOTES_SPLIT_007 from '@/components/OEBPS/Text/notes_split_007'
 import OEBPSTEXTNOTES_SPLIT_008 from '@/components/OEBPS/Text/notes_split_008'
 import OEBPSTEXTINDEX from '@/components/OEBPS/Text/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/OEBPS/Text/titlepage",
 			"name" : "OEBPS/Text/titlepage",
 			"component" : OEBPSTEXTTITLEPAGE
 		},
 		{
 			"path" : "/OEBPS/Text/copyrightpage",
 			"name" : "OEBPS/Text/copyrightpage",
 			"component" : OEBPSTEXTCOPYRIGHTPAGE
 		},
 		{
 			"path" : "/OEBPS/Text/dedication",
 			"name" : "OEBPS/Text/dedication",
 			"component" : OEBPSTEXTDEDICATION
 		},
 		{
 			"path" : "/OEBPS/Text/toc",
 			"name" : "OEBPS/Text/toc",
 			"component" : OEBPSTEXTTOC
 		},
 		{
 			"path" : "/OEBPS/Text/preface",
 			"name" : "OEBPS/Text/preface",
 			"component" : OEBPSTEXTPREFACE
 		},
 		{
 			"path" : "/OEBPS/Text/acknowledgment",
 			"name" : "OEBPS/Text/acknowledgment",
 			"component" : OEBPSTEXTACKNOWLEDGMENT
 		},
 		{
 			"path" : "/OEBPS/Text/part01",
 			"name" : "OEBPS/Text/part01",
 			"component" : OEBPSTEXTPART01
 		},
 		{
 			"path" : "/OEBPS/Text/ch01",
 			"name" : "OEBPS/Text/ch01",
 			"component" : OEBPSTEXTCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js